import React from "react"
import PropTypes from "prop-types"
import { Route, Navigate } from "react-router"
import { isAccountManager } from "../../constants"

const Authmiddleware = ({
  children,
  accountManagerOnly,
}) => {
  const authUser = localStorage.getItem("authUser")
  if (!authUser) {
    return (
      <Navigate
        to={"/login"}
      />
    )
  }
  if (accountManagerOnly && !isAccountManager(JSON.parse(authUser))) {
    return (
      <Navigate
        to={"/status-oder"}
      />
    )
  }
  return children;
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  accountManagerOnly: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
}

export default Authmiddleware
